
import { egyptData } from './egypt';
import { southAfricaData } from './southAfrica';
import { nigeriaData } from './nigeria';
import { kenyaData } from './kenya';
import { algeriaData } from './algeria';
import { africaExpansion2 } from './africaExpansion2';
import { africaExpansion3 } from './africaExpansion3';
import { africaExpansion4 } from './africaExpansion4';
import { africaExpansion5 } from './africaExpansion5';

export const africaCountries = [
  egyptData,
  // Usar versiones expandidas
  // southAfricaData - reemplazado por southAfricaExpanded2
  // nigeriaData - reemplazado por nigeriaExpanded2
  kenyaData,
  algeriaData,
  ...africaExpansion2, // Incluye Sudáfrica y Nigeria expandidos originales
  ...africaExpansion3, // Incluye Marruecos expandido original
  ...africaExpansion4, // Incluye expansiones Fase 9
  ...africaExpansion5  // Incluye Marruecos 100+ ciudades, Túnez y Sudán expandidos - Fase 12
];
